import React from "react";
import PropTypes from "prop-types";
import { trackEvent } from "../utils/analytics";

const ProjectCard = ({ title, imgSrc, desc, tags, projectLink, classes }) => {
  const handleProjectClick = () => {
    trackEvent("project_view", {
      project_name: title,
      destination_url: projectLink,
    });
  };

  const handleProjectLinkClick = () => {
    const isDemoLink = /https?:\/\//.test(projectLink) && !projectLink.includes("github.com");
    const eventName = isDemoLink ? "project_demo_click" : "project_github_click";

    trackEvent(eventName, {
      project_name: title,
      destination_url: projectLink,
    });
  };
  return (
    <div
      className={`relative flex flex-col md:flex-row p-6 rounded-2xl bg-zinc-800 hover:bg-zinc-700/50 active:bg-zinc-700/60 ring-1 ring-inset ring-zinc-50/5 transition-colors mt-5 ${classes}`}
    >
      <div className="flex flex-col justify-between w-full md:w-2/3 pr-4 order-2 md:order-1">
        <div>
          <h3 className="text-3xl sm:text-2xl font-bold text-white my-4">{title}</h3>

          <p className="text-sm text-zinc-400 mb-4">
            {desc}
          </p>

          <div className="flex flex-wrap gap-2 mb-4">
            {tags.map((tag, index) => (
              <span
                key={index}
                className="text-xs text-zinc-400 bg-zinc-50/5 px-3 py-1 rounded-lg"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>

        <div className="rounded-lg p-2 flex items-center gap-2 bg-white text-zinc-950 shrink-0 w-fit px-4">
          Visit
          <span className="material-symbols-rounded" aria-hidden="true">
            arrow_outward
          </span>
        </div>
      </div>

      <div className="w-full md:w-1/3 h-48 md:h-auto rounded-lg overflow-hidden order-1 md:order-2">
        <img
          src={imgSrc}
          alt={title}
          loading="lazy"
          className="w-full h-full object-cover aspect-square"
        />
      </div>

      <a
        href={projectLink}
        target="_blank"
        rel="noopener noreferrer"
        className="absolute inset-0 z-10"
        onClick={handleProjectLinkClick}
        onMouseEnter={handleProjectClick}
        aria-label={`Open ${title} project`}
      >
        <span className="sr-only">Open {title} project</span>
      </a>
    </div>
  );
};

ProjectCard.propTypes = {
  imgSrc: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  tags: PropTypes.array.isRequired,
  projectLink: PropTypes.string.isRequired,
  classes: PropTypes.string,
};

export default ProjectCard;
